module.exports = __webpack_public_path__ + "static/media/DA.8426500d.svg";